import i18n from '@/lib/i18n'

export default (Vue) => {
  Vue.config.productionTip = false

  function getTimeRange (type, hourDiff) {
    const date = new Date()

    if (type === 1) { // Hour selections
      const auxDate = new Date()
      const hours = date.getHours() - hourDiff

      return {
        from: new Date(auxDate.setHours(hours)),
        to: date
      }
    } else if (type === 2) { // This week
      const y = date.getFullYear()
      const m = date.getMonth()
      const first = date.getDate() - date.getDay() // First day is the day of the month - the day of the week
      const last = first + 6 // last day is the first day + 6

      return {
        from: new Date(new Date(y, m, first)),
        to: new Date(new Date(y, m, last))
      }
    } else if (type === 3) { // This month
      const y = date.getFullYear()
      const m = date.getMonth()
      const firstDay = new Date(y, m, 1)
      const lastDay = new Date(y, m + 1, 0)

      return {
        from: firstDay,
        to: lastDay
      }
    }
  }

  Vue.prototype.$eventHub = new Vue() // Global event bus

  Vue.prototype.$ponceConfig = {

    checkStatus (value) {
      if (value === 1) {
        return '#00d166'
      } else if (value === 2) {
        return '#4F5AB0'
      } else if (value === 3) {
        return '#999'
      } else {
        return '#f93a2f'
      }
    },
    sortArrayByDeviceName (dataArray) {
      return dataArray.sort((a, b) => {
        if (a.deviceName > b.deviceName) {
          return 1
        } else if (a.deviceName < b.deviceName) {
          return -1
        } else {
          return 0
        }
      })
    },
    sortArrayByName (dataArray) {
      return dataArray.sort((a, b) => {
        if (a.name > b.name) {
          return 1
        } else if (a.name < b.name) {
          return -1
        } else {
          return 0
        }
      })
    },
    timerTypes: {
      'diffHours': 1,
      'setWeek': 2,
      'setMonth': 3
    },
    timeFrames (range) {
      if (range === 'oneHour') {
        return getTimeRange(this.timerTypes['diffHours'], 1)
      } else if (range === 'sixHours') {
        return getTimeRange(this.timerTypes['diffHours'], 6)
      } else if (range === 'oneDay') {
        return getTimeRange(this.timerTypes['diffHours'], 24)
      } else if (range === 'twoDays') {
        return getTimeRange(this.timerTypes['diffHours'], 48)
      } else if (range === 'oneWeek') {
        return getTimeRange(this.timerTypes['diffHours'], 168)
      } else if (range === 'twoWeeks') {
        return getTimeRange(this.timerTypes['diffHours'], 336)
      } else if (range === 'thisWeek') {
        return getTimeRange(this.timerTypes['setWeek'])
      } else if (range === 'thisMonth') {
        return getTimeRange(this.timerTypes['setMonth'])
      }
    },
    organizationDemoId: 999,
    sortByEntityName (array) {
      return array.sort(function (a, b) {
        if (a.campaign.entityName < b.campaign.entityName) { return -1 }
        if (a.campaign.entityName > b.campaign.entityName) { return 1 }
        return 0
      })
    },
    states: {
      1: i18n.t('Config.irrigating'),
      2: i18n.t('Config.movement'),
      3: i18n.t('Config.off'),
      4: i18n.t('Config.failure')
    },
    numberRules: [
      v => !!v || i18n.t('Config.fieldIsRequired'),
      v => /^[+]?\d+([.]\d+)?$/.test(v) || i18n.t('Config.onlyNumbers')
    ],
    phoneRules: [
      v => !!v || i18n.t('Config.phoneIsRequired'),
      v => /^[+]{1}[0-9]{13}$/.test(v) || i18n.t('Config.formatRequired')
    ],
    phoneWithoutPrefixRules: [
      v => !!v || i18n.t('Config.phoneIsRequired'),
      v => /^[0-9]{11}$/.test(v) || i18n.t('Config.formatWithoutPrefixRequired')
    ],
    requiredRules: [
      v => !!v || i18n.t('Config.thisFieldIsRequired')
    ],
    /* latLonRules: [
      v => !!v || 'La latitud y Longitud es requerida',
      v => /^(\-?\d+(\.\d+)?).\s*(\-?\d+(\.\d+)?)$/.test(v) || 'Formato requerido: (-)38.002625'
    ], */
    numberOptionalRules: [
      v => /^[+]?\d+([.]\d+)?$/.test(v) || i18n.t('Config.onlyNumbers')
    ],
    passwordRules: [
      v => !!v || i18n.t('Config.passwordIsRequired'),
      v => (v && v.length >= 6) || i18n.t('Config.passwordRequirements')
    ],
    emailRules: [
      v => !!v || i18n.t('Config.emailIsRequired'),
      v => /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || i18n.t('Config.emailRule')
    ],
    lotNameRules: [
      v => !!v || i18n.t('Config.nameIsRequired'),
      v => (v && v.length <= 21) || i18n.t('Config.name21char')
    ],
    equipmentNameRules: [
      v => !!v || i18n.t('Config.nameIsRequired'),
      v => (v && v.length <= 16) || i18n.t('Config.name16char')
    ],
    organizationTypes: [
      { text: i18n.t('Config.grower'), value: 'grower' },
      { text: i18n.t('Config.company'), value: 'company' },
      { text: i18n.t('Config.corporation'), value: 'corporation' }
    ],
    deviceMode: [
      { text: i18n.t('Config.active'), value: true },
      { text: i18n.t('Config.inactive'), value: false }
    ],
    equipmentTypes: [
      { text: i18n.t('Config.pivot'), value: 1 },
      { text: i18n.t('Config.forwardAvance'), value: 2 }
    ],
    roles: [
      { value: 'farmhand' },
      { value: 'fieldman' },
      { value: 'manager' },
      { value: 'owner' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/constants/config.js